// extracted by css-extract-rspack-plugin
export default {"cls1":"UserListMenu-cls1_-Iy","cls2":"UserListMenu-cls2_iFC UserListMenu-cls1_-Iy"};